/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesCase from "../../../Stages/StagesCase";
import { stageFormDefinition as contractStageFormDefinition } from "../contract/stageFormDefinition";
import { FormDefinition } from "../../../../types/ProductService/ProductService";
import { BackofficeUser } from "../../../../types/BackofficeUser";
import { DataLeakContract } from "../../../../types/Products/ContractLaw/DataLeakContract";
import { FormElementPropsWithoutProduct } from "../../../../components/Case/CaseForm/FormElement";
import personFields from "../modules/personFields";

export function stageFormDefinition(
  product: DataLeakContract,
  currentUser?: BackofficeUser,
): ReturnType<FormDefinition<DataLeakContract>> {
  const personalTextMessageField: FormElementPropsWithoutProduct<DataLeakContract> = {
    type: "ExpandableTextField",
    path: `${product.productClassName}.personalTextMessage`,
    isDisabled: () => true,
    additionalProps: {
      multiline: true,
    },
  };

  const createdFields: FormElementPropsWithoutProduct<DataLeakContract>[] = [
    ...personFields({ path: `${product.productClassName}.client` }),
    personalTextMessageField,
  ];

  const dataCompletedFields: FormElementPropsWithoutProduct<DataLeakContract>[] = [
    ...contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_DATA_COMPLETED],
    personalTextMessageField,
  ];

  const dataLawFirmCompletedFields: FormElementPropsWithoutProduct<DataLeakContract>[] = [
    ...contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_DATA_COMPLETED_LAWFIRM],
    personalTextMessageField,
  ];

  const checkedFields: FormElementPropsWithoutProduct<DataLeakContract>[] = [
    ...contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_CHECKED],
    personalTextMessageField,
  ];

  return {
    [stagesCase.STAGE_CREATED]: createdFields,
    [stagesCase.STAGE_DATA_COMPLETED]: dataCompletedFields,
    [stagesCase.STAGE_WAITING_FOR_FEEDBACK]: dataCompletedFields,
    [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: dataLawFirmCompletedFields,
    [stagesCase.STAGE_CHECKED]: checkedFields,
    [stagesCase.STAGE_IN_PROGRESS]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_IN_PROGRESS],
    [stagesCase.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT
    ],
    [stagesCase.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED
    ],
    [stagesCase.STAGE_ACTION_REQUIRED]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_ACTION_REQUIRED
    ],
    [stagesCase.STAGE_PREPARE_LAWSUIT]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_PREPARE_LAWSUIT
    ],
    [stagesCase.STAGE_LAWSUIT]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_LAWSUIT],
    [stagesCase.STAGE_TRIAL]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_LAWSUIT],
    [stagesCase.STAGE_EVALUATE_JUDGEMENT]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_EVALUATE_JUDGEMENT
    ],
    [stagesCase.STAGE_LAWSUIT_COMPLETED]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_LAWSUIT_COMPLETED
    ],
    [stagesCase.STAGE_COMPLETED]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_COMPLETED],
  };
}
